import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import axios from 'axios'
import Loading from './components/Loading';
import NavBarTop from './components/NavBarTop';
import NavBarFooter from './components/NavBarFooter';
import AboutPage from './pages/AboutPage';
import HomePage from './pages/HomePage';
import RequestPage from './pages/RequestPage';
import ReviewPage from './pages/ReviewPage';
import { Container } from 'react-bootstrap'
import NotFound from './pages/NotFound';
import ErrorPage from './pages/ErrorPage';
import Spinner from 'react-bootstrap/Spinner'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faCheckSquare, faCoffee } from '@fortawesome/free-solid-svg-icons'
library.add(fab, faCheckSquare, faCoffee)

function App() {

  const [isConfigLoaded, setIsConfigLoaded] = useState(false);

  useEffect(() => {
    if (window.AppConfigSettings) {
      setIsConfigLoaded(true);
      console.log("[window.AppConfigSettings]", window.AppConfigSettings);
    } else {
      let url = './app-settings.json';

      if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        url = './app-settings-dev.json';
      }
      // console.log('config url', url);

      axios.get(url)
        .then(res => {
          // console.log("[res.data]", res.data);
          window.AppConfigSettings = res.data;
          setIsConfigLoaded(true);
        })
        .catch((error) => {
          console.log('config error', error.message);
        });
    }
  }, []);

  if (!isConfigLoaded) {
    return <Loading />
  }

  return (
    <div className="app-main">
      <NavBarTop />
      {/* <Container fluid="md" className="app-container"> */}
      <section className="app-main-content wrapper">
        <aside className="aside aside-1"></aside>

        <div className="main">
          <Switch>
            <Route exact path="/">
              {/* <HomePage /> */}
              <RequestPage />
            </Route>
            <Route path="/about">
              <AboutPage />
            </Route>
            <Route path="/request">
              <RequestPage />
            </Route>
            <Route path="/review">
              <ReviewPage />
            </Route>
            <Route path="/error">
              <ErrorPage />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </div>
        {/* <div className="app-container-right-half">
          <article>
            <h1>Right Half</h1>
            <p>Welcome to CHRGIS</p>
          </article>
        </div> */}

        <aside className="aside aside-2"></aside>
      </section>
      {/* </Container> */}
      <NavBarFooter />
    </div>
  );
}

export default App;
